/* eslint-disable react-hooks/exhaustive-deps */
import { useMutation } from "@apollo/client";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { removeFromBuiltDomains } from "../reducers/buildReducer";
import { pushMessage } from "../reducers/messagingReducer";
import { registerScreenChanges } from "../reducers/screenChangesReducer";
import { getIn, noop } from "../utilities/utils";
import LayoutWrapper from "./LayoutWrapper";
import SectionHeader from "./helper/SectionHeader";
import { useDomainSettings } from "../hooks/useDomainSettings";
import { EXCLUDE_URLS_MUTATION } from "../mutations/mutations";
import { InputTextarea } from "primereact/inputtextarea";


const ExcludeUrls = (props) => {
    const { currentDomain, currentCustomer, currentPreset } = useSelector((state) => state.userInformation);
    const [state, setState] = useState('');
    const [stateKvp, setStateKvp] = useState('');
    const [isMutationComplete, setMutationComplete] = useState(false);
    const DOMAIN_SETTINGS_MUTATION_CONTAINER = useDomainSettings({
        onCompleted() {
            setMutationComplete(true);
        },
    })
    const [excludeUrlsMutation] = useMutation(EXCLUDE_URLS_MUTATION);
    const dispatch = useDispatch();

    const handleChange = (event, type) => {
        const { value } = event.target;
        if (type === 'urls') {
            setState(value);
        } else if (type === 'kvps') {
            setStateKvp(value);
        }
        dispatch(registerScreenChanges("Disable Ads by URLs/KVPs"));
    };


    useEffect(() => {
        if (currentCustomer && currentDomain) {

            DOMAIN_SETTINGS_MUTATION_CONTAINER({
                domainId: currentDomain,
                customerId: currentCustomer
            })
                .then((response) => {
                    let customerInfo = JSON.parse(getIn(response, "data", "domainEditMutation", "customerInfo"));
                    let excludeUrls = customerInfo.ad_exclude_urls;
                    let excludeKvps = customerInfo.exclusion_kvps_globally;

                    setState(excludeUrls);
                    setStateKvp(excludeKvps);
                })
                .catch(() => {
                    dispatch(pushMessage("Disable Ads by URLs/KVPs", "There was an error while trying to get disable ads configurations", "error"));
                });
        }
    }, [currentDomain, currentCustomer, currentPreset]);


    function handleSave() {
        return excludeUrlsMutation({
            variables: {
                id: `${currentDomain}`,
                settingsData: state,
                settingsDataKVP: stateKvp,
            },
        })
            .then(() => {
                dispatch(pushMessage("Disable Ads by URLs/KVPs", "ExcludeUrls settings were saved"));
                removeFromBuiltDomains(currentDomain);
            })
            .catch(() => {
                throw new Error("There was an error trying to update the Disable Ads by URLs/KVPs");
            });
    }

    return (
        <LayoutWrapper model="domain" saveCallback={async () => handleSave()}>
            <div className={`p-panel p-component enabled-content`}>
                {isMutationComplete && (
                    <>
                        <SectionHeader screenName="Disable Ads by URLs/KVPs">
                            <p>
                                <strong>Disable Ads by URLs</strong>
                            </p>
                        </SectionHeader>

                        <div className="p-col-12 p-sm-12 p-md-9 p-lg-9">
                            <InputTextarea placeholder="Please add the URLs you want to disable all the ads." rows={15} cols={137} id={"ad_exclude_urls"} name="ad_exclude_urls" value={state} onChange={(e) => handleChange(e, 'urls')} />
                        </div>
                        <span className="small-notice p-mt-0 p-mb-5" style={{ marginBottom: '10px' }}> Please make sure to use only relative URLs. For example, <b>https://yourdomain.com/entertainment/</b> would become <b>/entertainment/</b> You can also use wildcards such as <b>/entertainment/*</b> to disable the ads on all pages under /entertainment/ URL path. Enter one value per line, up to 100.</span>

                        <SectionHeader screenName="Disable Ads by KVPs">
                            <p>
                                <strong>Disable Ads by KVPs</strong>
                            </p>
                        </SectionHeader>

                        <div className="p-col-12 p-sm-12 p-md-9 p-lg-9">
                            <InputTextarea placeholder="Please add the KVPs you want to disable all the ads." rows={15} cols={137} id={"exclusion_kvps_globally"} name="exclusion_kvps_globally" value={stateKvp} onChange={(e) => handleChange(e, 'kvps')} />
                        </div>
                        <span className="small-notice p-mt-0" style={{ marginBottom: '10px' }}> ⚠️ To exclude ads for specific kvp, add the kvp values under adgridConfig.kvp in the window, using the exact key names from the object, you can list multiple kvp on separate lines, following the format below. Example: To exclude ads for the sponsored-post tag(adgridConfig.kvp.tags), enter: tags|sponsored-post . Enter one value per line up to 100. </span>

                    </>
                )}
            </div>
        </LayoutWrapper>
    );
};

export default ExcludeUrls;
